import {EVENTS_NAME} from '../../config.js'

const {LEAD_TRIGGERED_RECOMMENDED_PHONE_CALLED_DETAIL} = EVENTS_NAME

// INPUT:  event='Lead Triggered', lead_type='Recommended Phone Called', seller_type='profesional'
// OUTPUT: ['Lead Recommended Detalle Profesionales']

export const getRecommendedPhoneDetailEvents = ({event, properties, isProfessionalSeller}) => {
  const matches =
    event === LEAD_TRIGGERED_RECOMMENDED_PHONE_CALLED_DETAIL.EVENT &&
    properties.lead_type === LEAD_TRIGGERED_RECOMMENDED_PHONE_CALLED_DETAIL.LEAD_TYPE &&
    isProfessionalSeller

  if (!matches) return []

  return [LEAD_TRIGGERED_RECOMMENDED_PHONE_CALLED_DETAIL.EVENT_OPTIMIZELY_PROFESSIONAL]
}
